export const userTypes = {
  Owner: "Owner",
  Manager: "Manager",
  Employee: "Employee",
  Vendor: "Vendor",
  GeneralManager: "GM",
  persoalAssistant: "PA",
  Company: "COMPANY",
  Task: "TASK",
  HrOfficer: "HROFFICER",
  Project: "PROJECT",
  addHrOfficer: "addHrOfficer",
  addProcurement: "addProcurement",
  officer: "officer",
  HrManager: "HRMANAGER",
  all: "ALL",
  Self: "Self",
  Po: "PO",
};
export const userLabels = {
  GeneralManager: 'General Manager',
  persoalAssistant: 'Personal Assistant',
  HrOfficer: 'HR Officer',
  Officer: 'Officer',
  Procurements: 'Procurement Officer',
}
export const sidebarType = {
  CHAT: "chat",
  CALENDAR: "calendar",
  EMAIL: "email",
};

export const moduleType = {
  FOOTER: "FOOTER",
};
export const moduleTypes = {
  Profile: "profile",
  Managetask: "managetask",
  Contactprivate: "contactprivate",
  Contactshare: "contactshare",
  TaskReport: "taskreport",
  AttendanceReport: "attendancereport",
  performanceReport: "performancereport",
  workloadReport: "workloadreport",
  staffReport: "staffreport",
  viewCalendar: "viewcalendar",
  calendar: "calendar",
  PORequest: "request",
  DASHBOARDFILTERS: "dashboardFilter",
};
